import type { SearchResultClickProperties } from './productEventPayloads';

/** Shared `search_result_click` payload for web SearchResults and native Explore. */
export const buildSearchResultClickProperties = (
  properties: SearchResultClickProperties,
): SearchResultClickProperties => ({ ...properties });
